export default __webpack_public_path__ + "static/media/SIFA_NL_SEQ12.258d0fcc.mp3";